"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class InsuranceCoverageRestrictions {
    constructor(partners, transportModes, commodities, equipmentTypes, truckloadTypes, freightClasses, assuredCountries, pickupCountries, portOfLoadingCountries, portOfDischargeCountries, deliveryCountries, shipperConsigneeCountries, fromCountries) {
        this.partners = partners;
        this.transportModes = transportModes;
        this.commodities = commodities;
        this.equipmentTypes = equipmentTypes;
        this.truckloadTypes = truckloadTypes;
        this.freightClasses = freightClasses;
        this.assuredCountries = assuredCountries;
        this.pickupCountries = pickupCountries;
        this.portOfLoadingCountries = portOfLoadingCountries;
        this.portOfDischargeCountries = portOfDischargeCountries;
        this.deliveryCountries = deliveryCountries;
        this.shipperConsigneeCountries = shipperConsigneeCountries;
        this.fromCountries = fromCountries;
    }
    get allStopCountries() {
        var _a, _b, _c, _d;
        return Array.from(new Set([
            ...((_a = this.pickupCountries) !== null && _a !== void 0 ? _a : []),
            ...((_b = this.deliveryCountries) !== null && _b !== void 0 ? _b : []),
            ...((_c = this.portOfLoadingCountries) !== null && _c !== void 0 ? _c : []),
            ...((_d = this.portOfDischargeCountries) !== null && _d !== void 0 ? _d : [])
        ]));
    }
    static fromObj(data) {
        return new InsuranceCoverageRestrictions(data === null || data === void 0 ? void 0 : data.partners, data === null || data === void 0 ? void 0 : data.transportModes, data === null || data === void 0 ? void 0 : data.commodities, data === null || data === void 0 ? void 0 : data.equipmentTypes, data === null || data === void 0 ? void 0 : data.truckloadTypes, data === null || data === void 0 ? void 0 : data.freightClasses, data === null || data === void 0 ? void 0 : data.assuredCountries, data === null || data === void 0 ? void 0 : data.pickupCountries, data === null || data === void 0 ? void 0 : data.portOfLoadingCountries, data === null || data === void 0 ? void 0 : data.portOfDischargeCountries, data === null || data === void 0 ? void 0 : data.deliveryCountries, data === null || data === void 0 ? void 0 : data.shipperConsigneeCountries, data === null || data === void 0 ? void 0 : data.fromCountries);
    }
}
exports.default = InsuranceCoverageRestrictions;
//# sourceMappingURL=insuranceCoverageRestrictions.class.js.map